const actions = {
    FETCH_SALARY_DECLARATIONS_ATTENDANCE: 'FETCH_SALARY_DECLARATIONS_ATTENDANCE',
    FETCH_MONTHLY_SALARIES: 'FETCH_MONTHLY_SALARIES',
    FETCH_MONTHLY_SALARY: 'FETCH_MONTHLY_SALARY',
    RESET_MONTHLY_SALARY: 'RESET_MONTHLY_SALARY',

    // 📌 Fetch all Monthly Salaries
    fetchSalaryDeclarationsAndAttendanceAction: (data) => {
        return {
            type: actions.FETCH_SALARY_DECLARATIONS_ATTENDANCE,
            data: data
        };
    },

    fetchMonthlySalariesAction: (data) => {
        return {
            type: actions.FETCH_MONTHLY_SALARIES,
            data: data
        };
    },

    // 📌 Reset Monthly Salary Form
    resetMonthlySalaryFormAction: () => {
        return {
            type: actions.RESET_MONTHLY_SALARY,
            data: null
        };
    },

    // 📌 Fetch single Monthly Salary
    fetchMonthlySalaryAction: (data) => {
        return {
            type: actions.FETCH_MONTHLY_SALARY,
            data: data
        };
    },
};

export default actions;
